export default __webpack_public_path__ + "static/media/note-header-icon.0ddac8f5.svg";